export const setMenuState = (payload) => async (dispatch) => {
  dispatch({ type: "MAIN_MENU", payload });
};
